import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../../index'

type LanguageState = {
  legalPersonalitySlug: string;
  lastPersistedLanguage?: string;
  lastPersistedAt?: number;
};

const initialStateLanguage: LanguageState = {
  legalPersonalitySlug: 'en',
  lastPersistedLanguage: undefined,
  lastPersistedAt: undefined
}

export const languageSlice = createSlice({
  name: 'language',
  initialState: initialStateLanguage,
  reducers: {
    addPersonalitySlug: (state: any, action: PayloadAction<string>) => {
      state.legalPersonalitySlug = action.payload
    },
    markLanguagePersisted: (state: LanguageState, action: PayloadAction<{ language: string; at: number }>) => {
      state.lastPersistedLanguage = action.payload.language;
      state.lastPersistedAt = action.payload.at;
    }
  }
});

export const { addPersonalitySlug, markLanguagePersisted } = languageSlice.actions;
export const languageSelector = (state: RootState) => state.language;
export default languageSlice.reducer;
